import { fallbackFontFamily } from './constants';
import { fixLightFontWeight } from './fixLightFontWeight';
const headingStyles = (tokens) => {
    const lt3 = {
        fontWeight: fixLightFontWeight(tokens.TextHeadingLight3FontWeight),
        fontSize: tokens.TextHeadingLight3FontSize,
        fontFamily: `${tokens.TextHeadingLight3FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingLight3LineHeight,
    };
    const lt4 = {
        fontWeight: fixLightFontWeight(tokens.TextHeadingLight4FontWeight),
        fontSize: tokens.TextHeadingLight4FontSize,
        fontFamily: `${tokens.TextHeadingLight4FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingLight4LineHeight,
    };
    const lt5 = {
        fontWeight: fixLightFontWeight(tokens.TextHeadingLight5FontWeight),
        fontSize: tokens.TextHeadingLight5FontSize,
        fontFamily: `${tokens.TextHeadingLight5FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingLight5LineHeight,
    };
    const md6 = {
        fontWeight: tokens.TextHeadingMedium6FontWeight,
        fontSize: tokens.TextHeadingMedium6FontSize,
        fontFamily: `${tokens.TextHeadingMedium6FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingMedium6LineHeight,
    };
    const md5 = {
        fontWeight: tokens.TextHeadingMedium5FontWeight,
        fontSize: tokens.TextHeadingMedium5FontSize,
        fontFamily: `${tokens.TextHeadingMedium5FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingMedium5LineHeight,
    };
    const md4 = {
        fontWeight: tokens.TextHeadingMedium4FontWeight,
        fontSize: tokens.TextHeadingMedium4FontSize,
        fontFamily: `${tokens.TextHeadingMedium4FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingMedium4LineHeight,
    };
    return {
        variants: {
            'primary-lt-3': {
                ...lt3,
                color: tokens.TextPrimary,
            },
            'lt-500-lt-5': {
                ...lt5,
                color: tokens.TextLight500,
            },
            'md-600-lt-5': {
                ...lt5,
                color: tokens.TextMedium600,
            },
            'lt-500-md-6': {
                ...md6,
                color: tokens.TextLight500,
            },
            'dk-800-md-6': {
                ...md6,
                color: tokens.TextDark800,
            },
            'dk-800-md-5': {
                ...md5,
                color: tokens.TextDark800,
            },
            'dk-800-md-4': {
                ...md4,
                color: tokens.TextDark800,
            },
            'blk-800-md-4': {
                ...md4,
                color: tokens.TextBlack800,
            },
            'blk-800-lt-3': {
                ...lt3,
                color: tokens.TextBlack800,
            },
            'dk-800-lt-4': {
                ...lt4,
                color: tokens.TextDark800,
            },
            'dk-800-lt-3': {
                ...lt3,
                color: tokens.TextDark800,
            },
            'md-600-lt-4': {
                ...lt4,
                color: tokens.TextMedium600,
            },
        },
    };
};
export default headingStyles;
